import { render, staticRenderFns } from "./ServiceSpotMessagesPage.vue?vue&type=template&id=a13aa932"
import script from "./ServiceSpotMessagesPage.vue?vue&type=script&lang=js"
export * from "./ServiceSpotMessagesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports